import UserInfo from './user_info.vue'

export default {
    install(Vue: { component: (componentName: string, component: object) => object }) {
        Vue.component('UserInfo', UserInfo)
    }
}
